import { func_validation, getTotalCountFromHeader } from "functions";

export function tableData(props) {
    const {
        userList,
        userGroupList,
        userListHeaders
    } = props;
    
    let userList_formatted = [];
    if (func_validation.isArrayNotEmpty(userList)) {
        userList_formatted = func_validation.cloneArrayOfObject(userList);
        userList_formatted.map((userDetail, userIndex) => {
            let userGroupMappings = func_validation.getObjectPropertyValue(userDetail, "UserGroupMappings");
            
            // Create list of user group names
            if (func_validation.isArrayNotEmpty(userGroupMappings)) {
                userList_formatted[userIndex]["UserGroup"] = [];
                userGroupMappings.map((userGroupMappingObj) => {
                    let userGroupId = func_validation.getObjectPropertyValue(userGroupMappingObj, "UserGroupId");

                    // Get the group name from list
                    if (func_validation.isArrayNotEmpty(userGroupList)) {
                        for (let i = 0; i < userGroupList.length; i++) {
                            let userGroupObj = userGroupList[i];
                            let id = func_validation.getObjectPropertyValue(userGroupObj, "ID");

                            if (userGroupId == id) {
                                let groupName = func_validation.getObjectPropertyValue(userGroupObj, "GroupName");
                                let obj = {};
                                obj["selectedIndex"] = i;
                                obj["groupName"] = groupName;

                                userList_formatted[userIndex]["UserGroup"].push(obj);
                                break;
                            }
                        }
                    }
                })
            }

            let userGroups = func_validation.cloneArrayOfObject(userList_formatted[userIndex]["UserGroup"]);
            if (func_validation.isArrayNotEmpty(userGroups)) {

                let obj = {};
                obj["UserGroup"] = userGroups;
                userList_formatted[userIndex]["subRows"] = [];
                userList_formatted[userIndex]["subRows"].push(obj);
            }
        })
    }

    return {
        userList_formatted,
        totalRecords: getTotalCountFromHeader(userListHeaders)
    }
}